import 'leaflet/dist/leaflet.css';
import './style.css';
import { loadState, Store } from './state/store';
import { startApp } from './ui/app';

const root = document.getElementById('app');
if (!root) throw new Error('Chybí kořenový element #app');

const store = new Store(loadState());
startApp(root, store);

// Offline studený start: v produkci cachujeme vlastní soubory service workerem.
// Selhání registrace nevadí — offline podpora je progresivní vylepšení.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}
